module.exports = __webpack_public_path__ + "img/manufacturing-3.71e02b4b.png";